import type { TOC } from '@ember/component/template-only';
import { not } from 'tio-ui/utilities';

interface CollapsibleSignature {
  Args: {
    isOpen?: boolean;
  };
  Element: HTMLDivElement;
  Blocks: { default: [] };
}

const Collapsible: TOC<CollapsibleSignature> = <template>
  {{! `hidden` is present iff the section is closed — direct expression
      instead of the easier-to-misread `if @isOpen false true` inversion. }}
  <div hidden={{not @isOpen}} ...attributes>
    {{yield}}
  </div>
</template>;

export default Collapsible;
